<template>
    <div class="qr-scanner-overlay position-fixed w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <button type="button" class="btn btn-outline-light qr-scanner-close" @click="$emit('close')"><i class="bi bi-x-lg"></i></button>
        <div class="qr-scanner-frame position-relative">
            <video ref="video" autoplay playsinline muted></video>
            <div class="qr-scanner-viewfinder"></div>
        </div>
        <p class="qr-scanner-hint mt-3">Apunta la cámara al código QR</p>
    </div>
</template>

<script>
import jsQR from 'jsqr'

// Decodes QR codes straight from the device camera - no server round-trip,
// works fully offline like JoinCodeQR.vue's rendering side. Requires HTTPS
// or localhost (getUserMedia is blocked on plain http:// LAN addresses).
export default {
    name: 'QrScanner',
    emits: ['detected', 'error', 'close'],
    data(){
        return {
            stream: null,
            raf_id: null,
            canvas: document.createElement('canvas'),
        }
    },
    mounted(){
        this.start_camera();
    },
    unmounted(){
        this.stop();
    },
    methods: {
        async start_camera(){
            try{
                this.stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: { ideal: 'environment' } },
                    audio: false,
                });
            }catch(e){
                this.$emit('error', 'No se pudo acceder a la cámara. Introduce el código manualmente.');
                return;
            }

            const video = this.$refs.video;
            if(!video){
                this.stop();
                return;
            }

            video.srcObject = this.stream;
            video.addEventListener('loadedmetadata', () => {
                this.canvas.width = video.videoWidth;
                this.canvas.height = video.videoHeight;
                this.scan_frame();
            }, { once: true });
        },
        scan_frame(){
            const video = this.$refs.video;
            if(!video || video.readyState !== video.HAVE_ENOUGH_DATA){
                this.raf_id = requestAnimationFrame(this.scan_frame);
                return;
            }

            const ctx = this.canvas.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(video, 0, 0, this.canvas.width, this.canvas.height);
            const image_data = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
            const code = jsQR(image_data.data, image_data.width, image_data.height);

            if(code && code.data){
                this.$emit('detected', code.data);
                return;
            }

            this.raf_id = requestAnimationFrame(this.scan_frame);
        },
        stop(){
            if(this.raf_id != null){
                cancelAnimationFrame(this.raf_id);
                this.raf_id = null;
            }
            if(this.stream){
                this.stream.getTracks().forEach((track) => track.stop());
                this.stream = null;
            }
        }
    }
}
</script>

<style scoped>
.qr-scanner-overlay{
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.92);
    z-index: 1080;
}
.qr-scanner-close{
    position: absolute;
    top: 1rem;
    right: 1rem;
}
.qr-scanner-frame{
    width: min(80vw, 360px);
    height: min(80vw, 360px);
    overflow: hidden;
    border-radius: 0.75rem;
}
.qr-scanner-frame video{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.qr-scanner-viewfinder{
    position: absolute;
    inset: 0;
    border: 3px solid rgba(255,255,255,0.7);
    border-radius: 0.75rem;
    pointer-events: none;
}
.qr-scanner-hint{
    color: var(--vc-paper-50, #f4f4f4);
    font-family: "Archivo", sans-serif;
    font-size: 0.85rem;
}
</style>
